import { combineReducers } from 'redux';
import { routeReducer as router } from 'redux-simple-router';
import db from 'store/reducers/db.reducer';

export default combineReducers({
  db,
  router
});



// WEBPACK FOOTER //
// ./src/store/root.reducer.js